import * as React from "react";
import { Translate } from "react-localize-redux";
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';

import './LevelsSVG.css';

function LevelsSVG(props) {
  return (
    <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
      <svg viewBox="0 0 161.13 141.02" {...props}>
        <g transform="translate(-21.114 -59.967)" className="enhancement-color-svg">
          <ellipse cx={173.05} cy={69.04} rx={9.051} ry={9.073} />
          <ellipse cx={173.05} cy={99.215} rx={9.051} ry={9.073} />
          <ellipse cx={173.05} cy={129.83} rx={9.051} ry={9.073} />
          <ellipse cx={173.05} cy={161.36} rx={9.051} ry={9.073} />
          <ellipse cx={173.03} cy={191.6} rx={9.051} ry={9.073} />
          <path d="M170.63 107.46h5.17v13.869h-5.17zM170.63 138.05h5.17v14.909h-5.17zM170.59 168.96h5.206v14.79h-5.206zM170.625 76.44l5.17.947V91.74l-5.17-.948z" />
        </g>
        <g className="main-color-svg">
          <g
            stroke="var(--main-color)"
            strokeWidth={0.257}
            transform="translate(-21.114 -59.967)"
          >
            <ellipse cx={173.08} cy={99.261} rx={7.359} ry={7.319} />
            <ellipse cx={173.14} cy={129.9} rx={7.359} ry={7.319} />
            <ellipse cx={173.15} cy={161.42} rx={7.359} ry={7.319} />
            <ellipse cx={173.13} cy={191.72} rx={7.359} ry={7.319} />
            <ellipse cx={173.1} cy={69.07} rx={7.359} ry={7.319} />
          </g>
          <path d="M0 1.658h151.85v14.893H0z" />
        </g>
        <text
          transform="matrix(.91073 0 0 1 -14.264 -61.623)"
          x={24.568} y={72.674}
          fontFamily="Montserrat"
          fontSize={7.408} fontWeight={500}
          className="light"
        >
          <Translate id="levels.title">Descubre cómo es trabajar con nosotros</Translate>
        </text>

        <text
          transform="matrix(.81307 0 0 .89216 16.761 -56.66)"
          x={144.8} y={99.5}
          fontFamily="Montserrat" textAnchor="end"
          fontSize={7.056} fontWeight={600}
        >
          <Translate id="levels.lv1.title">¡Aquí empieza la aventura!</Translate>
        </text>
        <foreignObject
          transform="matrix(1 0 0 1.0813 -23.718 -67.986)"
          x={44} y={94}
          width={114} height={18}
          fontFamily="Montserrat"
          fontSize={4.586} fontWeight={600}
        >
          <p className="text-right"><Translate id="levels.lv1.text">Ponte en contacto con nosotros y cuéntanos tu idea, nos atrevemos con todo.</Translate></p>
        </foreignObject >
        <text
          transform="matrix(.8292 0 0 .91989 7.608 -26.857)"
          x={153} y={99.5}
          fontFamily="Montserrat" textAnchor="end"
          fontSize={6.867} fontWeight={600}
        >
          <Translate id="levels.lv2.title">Subimos los primeros niveles.</Translate>
        </text>
        <foreignObject
          transform="matrix(1 0 0 1.0813 -23.6 -35.385)"
          x={44} y={94}
          width={114} height={18}
          fontFamily="Montserrat"
          fontSize={4.586} fontWeight={600}
        >
          <p className="text-right"><Translate id="levels.lv2.text">Con esta idea crearemos varias propuestas para que decidas cuál encaja mejor.</Translate></p>
        </foreignObject >
        <text
          transform="matrix(.8292 0 0 .91 15.569 4.799)"
          x={143.4} y={99.5}
          fontFamily="Montserrat" textAnchor="end"
          fontSize={6.867} fontWeight={600}
        >
          <Translate id="levels.lv3.title">Llegamos a medio camino.</Translate>
        </text>
        <foreignObject
          transform="matrix(1 0 0 1.0813 -23.6 -4.297)"
          x={44} y={94}
          width={114} height={18}
          fontFamily="Montserrat"
          fontSize={4.586} fontWeight={600}
        >
          <p className="text-right"><Translate id="levels.lv3.text">Juntos le daremos forma al diseño con mimo y detalle para convertirla en realidad.</Translate></p>
        </foreignObject >
        <foreignObject
          transform="matrix(1 0 0 1.0813 -23.6 15.736)"
          x={44} y={94}
          width={114} height={18}
          fontFamily="Montserrat"
          fontSize={4.586} fontWeight={600}
        >
          <p className="text-right"><Translate id="levels.lv4.text">Pulimos y abrillantamos el producto hasta que quede digno del...</Translate></p>
        </foreignObject >
        <text
          transform="matrix(.8292 0 0 .91989 55.641 47.323)"
          x={95} y={99.5}
          fontFamily="Montserrat" textAnchor="end"
          fontSize={6.867} fontWeight={600}
        >
          <Translate id="levels.lv4.title">Máximo nivel</Translate>
        </text>

        <g fontSize={10.583} fontFamily="Montserrat" fontWeight={600}>
          <text
            className="light"
            transform="matrix(.42874 0 0 .51746 75.787 -11.076)"
            x={169.416} y={100.999}
          >
            Lv1
          </text>
          <text
            className="light"
            transform="matrix(.42874 0 0 .51746 74.511 19.611)"
            x={169.416} y={100.999}
          >
            Lv10
          </text>
          <text
            className="light"
            transform="matrix(.42874 0 0 .51746 73.944 51.053)"
            x={169.416} y={100.999}
          >
            Lv50
          </text>
          <text
            className="light"
            transform="matrix(.42874 0 0 .51746 72.952 81.623)"
            x={169.416} y={100.999}
          >
            Lv100
          </text>
        </g>
      </svg>
    </ScrollAnimation>
  )
}

export default LevelsSVG
